import React from 'react';
import { jumpTo } from '@/navigate'
import './index.scss';
import Tips from "../../components/tips";
import Msg from "../../components/message";
import BgAudio from "./bgAudio";
import { toJS } from 'mobx'
import { inject, observer } from "mobx-react";
@inject("ScoreStore")
@observer
class App extends React.Component {
    state = {
        zlen: 3,
        plen: 3,
        maxlen: 7,
        mainPos: {},
        minorPos: {},
        subTime: 0,
        errorMsg: ""
    }
    zlenRender() {
        let zInput = [];
        for (let i = 0; i < this.state.zlen; i++) {
            zInput.push(<div key={i} className="form_item">
                <input placeholder="请输入主穴名称" autoComplete="off" name={`main${i}`} onChange={(e) => { this.addMainPos(e) }} />
            </div>)
        }
        return zInput;
    }
    plenRender() {
        let pInput = [];
        for (let i = 0; i < this.state.plen; i++) {
            pInput.push(<div key={i} className="form_item">
                <input placeholder="请输入配穴名称" autoComplete="off" name={`minor${i}`} onChange={(e) => { this.addMinorPos(e) }} />
            </div>)
        }
        return pInput;
    }
    addMainPos(e) {
        let target = e.currentTarget;
        let obj = {};
        obj[target.name] = target.value;
        this.setState({
            mainPos: { ...this.state.mainPos, ...obj }
        })
    }
    addMinorPos(e) {
        let target = e.currentTarget;
        let obj = {};
        obj[target.name] = target.value;
        this.setState({
            minorPos: { ...this.state.minorPos, ...obj }
        })
    }
    zlenAdd() {
        let len = this.state.zlen;
        if (len < this.state.maxlen) {
            this.setState({
                zlen: len + 1
            })
        }

    }
    zlenDel() {
        let len = this.state.zlen;
        if (len > 1) {
            let mainPos = this.state.mainPos;
            let keys = Object.keys(mainPos);
            if (keys.length) {
                if (len == keys.length) {
                    delete mainPos[keys[keys.length - 1]]
                }
            }
            this.setState({
                zlen: len - 1,
                mainPos: mainPos
            })
        }
    }
    plenAdd() {
        let len = this.state.plen;
        if (len < this.state.maxlen) {
            this.setState({
                plen: len + 1
            })

        }
    }
    plenDel() {
        let len = this.state.plen;
        if (len > 1) {
            let minorPos = this.state.minorPos;
            let keys = Object.keys(minorPos);
            if (keys.length) {
                if (len == keys.length) {
                    delete minorPos[keys[keys.length - 1]]
                }
            }
            this.setState({
                plen: len - 1,
                minorPos: minorPos
            })
        }
    }
    sub() {
        this.setState({
            subTime: this.state.subTime + 1
        }, () => {
            let classInfo = this.props.ScoreStore.classInfo;
            let mainPosition = toJS(classInfo.mainPosition);
            let mainLen = mainPosition.length;
            let minorPosition = toJS(classInfo.minorPosition);
            let minorLen = minorPosition.length;
            let mainPos = this.state.mainPos;
            let minorPos = this.state.minorPos;
            let mainFlag = 0, minorFlag = 0;
            for (let i in mainPos) {
                let index = mainPosition.indexOf(mainPos[i])
                if (index != -1) {
                    if (this.state.subTime == 1) {
                        this.props.ScoreStore.addScore(3)
                    }
                    this.props.ScoreStore.recordInput(mainPos[i])
                    mainPosition.splice(index, 1);
                    mainFlag = mainFlag + 1;
                }
            }
            for (let i in minorPos) {
                let index = minorPosition.indexOf(minorPos[i])
                if (index != -1) {
                    if (this.state.subTime == 1) {
                        this.props.ScoreStore.addScore(2)
                    }
                    this.props.ScoreStore.recordInput(minorPos[i])
                    minorPosition.splice(index, 1);
                    minorFlag = minorFlag + 1;
                }

            }
            if (this.state.subTime == 1) {
                let mainScore = (mainLen - mainFlag) * 3;
                let minorScore = (minorLen - minorFlag) * 2;
                if (mainScore > 0) {
                    this.props.ScoreStore.setPenalties("主穴输入", mainScore)
                }
                if (minorScore > 0) {
                    this.props.ScoreStore.setPenalties("配穴输入", minorScore)
                }


            }
            if (mainFlag >= 3) {
                jumpTo("Guide5Loading")
            }
            else {
                this.props.ScoreStore.clearUserInput();
                this.setState({
                    errorMsg: "主穴选择不正确"
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            errorMsg: ""
                        })
                    }, 2000)
                })
            }

        })

    }
    render() {
        return (
            <div className="page page-guide guide_room">
                <div className="room_name">就诊室</div>
                <div className="form_view">
                    <div className="form_tit tit_l">针灸治疗穴位处方</div>
                    <div className="form_flex">
                        <div className="form_bd">
                            <div className="item_type">
                                <div>主穴</div>
                                <div>{this.state.zlen < this.state.maxlen && <i className="icon_add" onClick={() => { this.zlenAdd() }}></i>}{this.state.zlen > 1 && <i className="icon_del" onClick={() => { this.zlenDel() }}></i>}</div>
                            </div>
                            {this.zlenRender()}
                        </div>
                        <div className="form_bd">
                            <div className="item_type">
                                <div>配穴</div>
                                <div>{this.state.plen < this.state.maxlen && <i className="icon_add" onClick={() => { this.plenAdd() }}></i>}{this.state.plen > 1 && <i className="icon_del" onClick={() => { this.plenDel() }}></i>}</div>
                            </div>
                            {this.plenRender()}
                        </div>
                    </div>
                    <div className="form_btn">
                        <button onClick={() => { this.sub() }}>确定</button>
                    </div>
                </div>
                <audio src={require("../../assets/audio/step_4.mp3")} autoPlay={true} />
                <Msg msg={this.state.errorMsg} />
                <Tips init={false} studyTips={1} />
                <BgAudio />
            </div>
        );
    }
}

export default App;
